<template>
  <div>
  	<div class="label">标题：</div>
    <div class="title">{{info.title}}</div>
    <div class="label">图文详情：</div>
    <div class="content" v-html="info.content"></div>
    <el-button type="primary" @click="backBtnClick" class="backBtn">返回</el-button>
  </div>
</template>

<script>
import { messagePushDetail } from '@/api/content-manage'
export default {
  name: 'messagedetail',
  data() {
  	return {
  		info: {
  		}
  	}
  },
  mounted() {
  	this.getMessageDetail(this.$route.query.uuid)
  },
  methods: {
  	async getMessageDetail(uuid) {
       const { data, status} = await messagePushDetail(uuid);
       if (status !== 200) return
       this.info = data
  	},
  	backBtnClick() {
  		this.$router.go(-1);
  	}
  }
}
</script>

<style lang="less" scoped>
.title {
	border: 1px solid #000;
	border-radius: 10px;
	padding: 10px;
	max-width: 300px;
	margin-top: 15px;
	text-align: center;
}
.label {
	margin-top: 20px;
	font-size: 20px;
}
.backBtn {
	display: block;
	margin: 40px auto;
}
</style>
